module.exports = __webpack_public_path__ + "img/referral.642db9c.png";